
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytournearnagpur() {



  const cardData =
  {
    keyword: ' 1 Day Tour Near Nagpur',
    heading:  'Woodland Escape: 1 Day Tour Near Nagpur',
    headingDescription: '1 Day Tour Near Nagpur is the perfect way to unwind and explore nature without traveling far from the city. Surrounded by scenic lakes, lush green forests, and serene picnic spots, these one-day destinations offer the ideal mix of relaxation and adventure. Whether you’re planning a family picnic, a quick friends’ getaway, or a corporate day out, locations near Nagpur such as Ramtek, Khindsi Lake, Pench Tiger Reserve, and Ambazari Garden provide unique experiences. Enjoy boating, wildlife exploration, and local cuisine while reconnecting with nature — making your short trip a refreshing escape from daily routine.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



    "services": [
    {
      "name": "1 Day Tour Near Nagpur",
      "description": "Woodland Escape Resort offers an ideal 1‑day tour near Nagpur. Spend a relaxing day amidst lush greenery, enjoy outdoor activities like nature walks, bird watching, and fun farm experiences. Unwind by the pond, have a picnic lunch, and experience a refreshing escape from the city hustle, all in a serene countryside setting."
    },
    {
      "name": "Nagpur One Day Trip",
      "description": "Plan a one‑day trip from Nagpur to Woodland Escape Resort for a full day of fun, relaxation, and excursions in a scenic setting. Explore the beautiful gardens, enjoy interactive activities for all ages, and savor local cuisine. Perfect for families, friends, and couples looking for a memorable day out."
    },
    {
      "name": "Nagpur Day Tour Packages",
      "description": "Woodland Escape Resort features special day tour packages from Nagpur city, including guided nature walks, farm tours, outdoor games, and delicious meals. Guests can enjoy recreational activities, relax in shaded areas, and experience a peaceful rural environment that rejuvenates the mind and body."
    },
    {
      "name": "Nagpur Sightseeing Tour",
      "description": "Combine your stay at Woodland Escape Resort with sightseeing around Nagpur. Visit local landmarks and cultural sites in the morning and return to the resort for relaxation, nature trails, and engaging outdoor activities. A perfect blend of exploration and leisure in one day."
    },
    {
      "name": "Affordable 1 Day Tour Nagpur",
      "description": "Enjoy an affordable 1‑day tour option at Woodland Escape Resort. Experience excellent value for money with a variety of activities, comfortable amenities, and a calm environment. Perfect for budget-conscious travelers looking for a refreshing escape near Nagpur."
    },
    {
      "name": "Nagpur Local Tour",
      "description": "Explore the local surroundings of Nagpur with a day-out at Woodland Escape Resort. Engage in short nature trails, interact with farm animals, try simple outdoor games, and enjoy freshly prepared meals. Ideal for a quick, refreshing break without traveling far from the city."
    },
    {
      "name": "Nagpur One Day Travel",
      "description": "Woodland Escape Resort provides one‑day travel convenience from Nagpur. Arrive in the morning, enjoy the resort’s amenities like open lawns, nature walks, and recreational activities, and return by evening fully refreshed. A hassle-free and enriching day experience awaits."
    },
    {
      "name": "Nagpur City Tour",
      "description": "After a city tour in Nagpur, retreat to Woodland Escape Resort to unwind in nature. Enjoy peaceful walks, serene ponds, scenic views, and a variety of outdoor activities. Ideal for couples, families, and groups looking to balance sightseeing with relaxation."
    },
    {
      "name": "Nagpur Day Out Packages",
      "description": "Woodland Escape Resort offers day‑out packages near Nagpur, including guided nature walks, fun outdoor games, farm activities, and wholesome meals. Perfect for family outings, corporate picnics, or a refreshing day with friends in a tranquil countryside environment."
    },
    {
      "name": "Nagpur Nearby Attractions Tour",
      "description": "Located near Nagpur, Woodland Escape Resort provides easy access to nearby attractions. After exploring local points of interest, guests can relax at the resort, enjoy scenic views, participate in outdoor activities, and make the most of a peaceful day in nature."
    },
    {
      "name": "Nagpur Weekend Tour",
      "description": "Make it a weekend outing near Nagpur at Woodland Escape Resort. Enjoy two days of nature, relaxation, outdoor fun, and comfortable stay options. Ideal for families, friends, and couples seeking a refreshing escape from city life while indulging in activities and leisure."
    },
    {
      "name": "Nagpur Family Day Trip",
      "description": "Perfect for families near Nagpur: Woodland Escape Resort offers a family-friendly day trip with spacious outdoor areas, fun games for kids, guided nature walks, picnic spots, and opportunities for bonding in a calm and secure environment surrounded by greenery."
    },
    {
      "name": "Nagpur Short Tour",
      "description": "For a short escape from Nagpur, visit Woodland Escape Resort for a half-day or full-day experience. Enjoy garden walks, farm-based activities, relaxation spots, and light refreshments. Ideal for busy professionals or families looking for a quick, rejuvenating getaway."
    },
    {
      "name": "Nagpur Day Tour Booking",
      "description": "Book your day tour at Woodland Escape Resort near Nagpur in advance. Ensure a hassle-free itinerary including guided activities, meals, nature trails, and leisure time. Perfect for groups, families, and solo travelers seeking a well-organized and relaxing day."
    },
    {
      "name": "Nagpur Excursion Packages",
      "description": "Excursion packages from Nagpur to Woodland Escape Resort include engaging outdoor activities, farm interactions, scenic walks, and a serene environment to relax. Ideal for educational trips, family outings, and group excursions seeking a combination of fun and nature."
    }
  ],
  "tableData": [
    ["- 1 Day Tour Near Nagpur", "- Nagpur One Day Trip"],
    ["- Nagpur Day Tour Packages", "- Nagpur Sightseeing Tour"],
    ["- Affordable 1 Day Tour Nagpur", "- Nagpur Local Tour"],
    ["- Nagpur One Day Travel", "- Nagpur City Tour"],
    ["- Nagpur Day Out Packages", "- Nagpur Nearby Attractions Tour"],
    ["- Nagpur Weekend Tour", "- Nagpur Family Day Trip"],
    ["- Nagpur Short Tour", "- Nagpur Day Tour Booking"],
    ["- Nagpur Excursion Packages", ""]
  ],
  



  whychoose: [
  {
    "WhyChooseheading": "Refreshing 1 Day Tour Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect choice for a 1-day tour near Nagpur. Nestled in a serene forest setting, it offers a peaceful retreat surrounded by tall trees, chirping birds, and fresh air. Whether you’re planning a family trip, a short nature break, or a getaway with friends, the resort provides the ideal balance of relaxation and adventure within a short drive from Nagpur."
  },
  {
    "WhyChooseheading": "Beautiful Forest Location",
    "WhyChoosedescription": "Experience the charm of untouched nature at Woodland Escape Resort. Surrounded by dense forest greenery, this scenic hideaway offers a tranquil ambiance that helps you unwind from city life. The sound of rustling leaves, flowing breeze, and distant calls of forest birds create a rejuvenating atmosphere that’s perfect for nature lovers and photography enthusiasts."
  },
  {
    "WhyChooseheading": "Comfortable Day Stay Facilities",
    "WhyChoosedescription": "Even on a short visit, comfort matters. Woodland Escape Resort offers well-maintained cottages, shaded rest zones, and forest-view sit-outs where guests can relax between activities. Whether you choose to spend time indoors or enjoy the outdoor breeze, every corner is designed to make your 1-day visit cozy and memorable."
  },
  {
    "WhyChooseheading": "Fun and Engaging Activities",
    "WhyChoosedescription": "Your day at Woodland Escape Resort can be as exciting or as relaxing as you like. Explore guided forest walks, wildlife spotting, zip-lining, or cycling through natural trails. Families can enjoy indoor games, nature picnics, and evening bonfires. There’s something special for everyone — from adventure seekers to peace lovers."
  },
  {
    "WhyChooseheading": "Delicious Forest-Themed Cuisine",
    "WhyChoosedescription": "Enjoy farm-fresh and locally inspired meals prepared with organic ingredients. Our kitchen serves a variety of traditional and regional dishes that reflect the authentic flavors of the region. From hearty breakfasts to delicious lunches, every meal enhances your forest retreat experience."
  },
  {
    "WhyChooseheading": "Perfect for Families and Groups",
    "WhyChoosedescription": "Woodland Escape Resort is an excellent destination for families, school picnics, and corporate groups looking for a unique 1-day outing near Nagpur. With vast open spaces, forest trails, and group activities, it’s ideal for team bonding, nature learning, or simply spending quality time together."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located conveniently near Nagpur, Woodland Escape Resort is just a short scenic drive away. The smooth road connectivity ensures a hassle-free trip, allowing you to make the most of your day in nature. It’s the perfect quick escape from the city — close enough for convenience, yet far enough to feel truly away from it all."
  }
]

  
  



  }

  const faqData = [
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "Woodland Escape Resort is located just about 45 km from Nagpur, making it an ideal destination for a quick one-day trip or weekend getaway. The scenic drive takes around 1 to 1.5 hours, offering a refreshing escape into nature."
  },
  {
    question: "What can we do on a 1-day tour at Woodland Escape Resort?",
    answer: "Our 1-day tour package is packed with activities that let you relax and reconnect with nature. Enjoy guided nature walks, boating, bird watching, adventure games, and a delicious farm-fresh lunch. It’s a perfect blend of relaxation and recreation."
  },
  {
    question: "Is food included in the 1-day tour package?",
    answer: "Yes, the 1-day tour package includes welcome drinks, a traditional Maharashtrian or local countryside lunch, and evening tea with snacks. We use fresh, locally-sourced ingredients to give you an authentic taste of the region."
  },
  {
    question: "Can families and kids enjoy the day tour?",
    answer: "Absolutely! Woodland Escape Resort is a family-friendly destination. We have a safe and enjoyable environment for kids, with open play areas, animal interactions, and fun outdoor games suitable for all age groups."
  },
  {
    question: "Do you offer corporate or group 1-day packages?",
    answer: "Yes, we specialize in group bookings and corporate day outings. From team-building activities to customized meals and adventure challenges, our team ensures a memorable and productive experience for your group."
  },
  {
    question: "How can I book a 1-day tour at Woodland Escape Resort?",
    answer: "Booking your 1-day tour is simple! You can call our reservations team, reach out via WhatsApp, or visit our official website to book online. We recommend booking a few days in advance, especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Anil & Family, Nagpur",
    text: "We had an amazing one-day trip to Woodland Escape Resort! The peaceful environment, delicious food, and fun activities made it a perfect day out. The kids loved the nature trails and boating. Highly recommended for families near Nagpur!"
  },
  {
    name: "Sunita & Team, Nagpur",
    text: "Our office team visited Woodland Escape Resort for a one-day corporate outing, and it was fantastic! The staff was very accommodating, the food was great, and the location was just beautiful. Perfect spot for a quick escape from city life."
  }
];

      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "1 Day Tour Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/1-day-tour-near-nagpur.jpg",
  "description": "Explore exciting 1 Day Tours near Nagpur with Woodlandescape Resort. Enjoy scenic views, comfortable travel, and curated sightseeing packages for families and groups. Book your Nagpur day tour today for an unforgettable experience.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "956"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/1-day-tour-near-nagpur"
  }
};



  return (
    <div>
<Helmet>
  <title>1 Day Tour Near Nagpur | Nagpur Day Trips & Sightseeing | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Explore the best 1 Day Tour near Nagpur with Woodlandescape Resort. Discover top local attractions, sightseeing spots, and family-friendly day trips. Affordable Nagpur day tour packages available now!" 
  />
  <meta 
    name="keywords" 
    content="1 Day Tour Near Nagpur, Nagpur One Day Trip, Nagpur Day Tour Packages, Nagpur Sightseeing Tour, Affordable 1 Day Tour Nagpur, Nagpur Local Tour, Nagpur One Day Travel, Nagpur City Tour, Nagpur Day Out Packages, Nagpur Nearby Attractions Tour, Nagpur Weekend Tour, Nagpur Family Day Trip, Nagpur Short Tour, Nagpur Day Tour Booking, Nagpur Excursion Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/1.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytournearnagpur;